var map = {
	"./auth/index.js": 9537,
	"./bank/index.js": 8076,
	"./deposit/index.js": 8436,
	"./games/index.js": 3937,
	"./home/index.js": 3349,
	"./kyc/index.js": 8235,
	"./lucky-draw/index.js": 3059,
	"./profile/index.js": 2427,
	"./promotion/index.js": 7431,
	"./rebate/index.js": 8013,
	"./transaction/index.js": 5826,
	"./wallet-transfer/index.js": 5081,
	"./withdrawal/index.js": 8541
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 939;